import { render, staticRenderFns } from "./workflowSettingDialog.vue?vue&type=template&id=7b58d80a&scoped=true"
import script from "./workflowSettingDialog.vue?vue&type=script&lang=js"
export * from "./workflowSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./workflowSettingDialog.vue?vue&type=style&index=0&id=7b58d80a&prod&scoped=true&lang=css"
import style1 from "./workflowSettingDialog.vue?vue&type=style&index=1&id=7b58d80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b58d80a",
  null
  
)

export default component.exports